export default __webpack_public_path__ + "xcode.5a512a57.png";